import { AnyTeamEntityVersion, TeamSettings } from '@uploadcam/common';
import { CollectionReference, doc, setDoc } from 'firebase/firestore';

export class UpdateTeamSettingsInteractor {
  constructor(private readonly collection: CollectionReference<AnyTeamEntityVersion>) {}

  public async execute(teamId: string, settings: Partial<TeamSettings>): Promise<void> {
    await setDoc(doc(this.collection, teamId), { settings }, { merge: true });
  }
}
